import { ref, get, remove } from 'firebase/database';
import { db } from './firebaseConfig';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

async function cleanupOldRecords(path, getTimestamp) {
  try {
    const snapshot = await get(ref(db, path));
    const data = snapshot.val();
    if (!data) return;

    const cutoff = Date.now() - THIRTY_DAYS_MS;
    const deletions = [];

    Object.keys(data).forEach(key => {
      const record = data[key];
      const timestamp = getTimestamp(record);
      if (timestamp && timestamp < cutoff) {
        deletions.push(remove(ref(db, path + '/' + key)));
      }
    });

    if (deletions.length > 0) {
      await Promise.all(deletions);
      console.log('Cleanup: removed ' + deletions.length + ' old records from ' + path);
    }
  } catch (error) {
    console.log('Cleanup error for ' + path + ':', error);
  }
}

export async function runAppCleanup() {
  const lastCleanup = parseInt(localStorage.getItem('guningo_last_cleanup') || '0');
  const oneDayMs = 24 * 60 * 60 * 1000;

  // Only run once per day, not on every single page load,
  // to avoid unnecessary Firebase reads.
  if (Date.now() - lastCleanup < oneDayMs) return;
  localStorage.setItem('guningo_last_cleanup', Date.now().toString());

  await cleanupOldRecords('rideHistory', (r) => (r.archivedAt ? new Date(r.archivedAt).getTime() : null));
  await cleanupOldRecords('notifications', (r) => r.timestamp || null);

  // Chats are nested (chats/{chatId}/messages/{msgId}), handled separately.
  try {
    const chatsSnapshot = await get(ref(db, 'chats'));
    const chatsData = chatsSnapshot.val();
    if (chatsData) {
      const cutoff = Date.now() - THIRTY_DAYS_MS;
      for (const chatId of Object.keys(chatsData)) {
        const messages = chatsData[chatId]?.messages;
        if (!messages) continue;
        const messageKeys = Object.keys(messages);
        const allOld = messageKeys.every(msgKey => {
          const msg = messages[msgKey];
          return msg.timestamp && msg.timestamp < cutoff;
        });
        if (allOld && messageKeys.length > 0) {
          await remove(ref(db, 'chats/' + chatId));
        }
      }
    }
  } catch (error) {
    console.log('Chat cleanup error:', error);
  }
}